import { useTracking } from 'react-tracking';

import { getPortfoliosCountByLimits } from '@/features/portfolio/utils';

import { usePortfolios, type Portfolio } from '@/hooks/portfolio/usePortfolio';
import { useEffect, useRef } from 'react';

type Props = {
  portfolio: Portfolio;
};

export const TrackLandEvent = ({ portfolio }: Props) => {
  const ref = useRef(false);
  const { trackEvent } = useTracking({
    type: 'track',
  });
  const { data: portfolios = [] } = usePortfolios();

  useEffect(() => {
    if (ref.current === false && portfolios.length > 0) {
      const { fullyLimitedPortfolios, partiallyLimitedPortfolios } =
        getPortfoliosCountByLimits(portfolios);
      const totalPortfolios = portfolios.length;

      const isPortfolioFullyLimited = portfolio.isAnalysisRestricted;
      const isPortfolioPartiallyLimited = !isPortfolioFullyLimited
        ? portfolio.holdings.some((holding) => holding.isAnalysisRestricted)
        : false;

      trackEvent({
        action: 'landed',
        fullyLimitedPortfolios,
        partiallyLimitedPortfolios,
        totalPortfolios,
        nonLimitedPortfolios:
          totalPortfolios -
          (fullyLimitedPortfolios + partiallyLimitedPortfolios),
        limitStatus: isPortfolioFullyLimited
          ? 'yes'
          : isPortfolioPartiallyLimited
            ? 'partially'
            : 'no',
      });
      ref.current = true;
    }
  }, [portfolio, portfolios, trackEvent]);

  return null;
};
